import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { User } from 'src/app/model/users/users';
import { UserService } from 'src/app/services/http/user/user.service';
import { EditUserComponent } from './edit-user/edit-user.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  public usersList!: User[];

  get displayedColumn(): string[] {
    const result: string[] = ['login', 'nom', 'prenom', 'edit', 'delete'];
    return result;
  }

  constructor(private userService: UserService, public dialog : MatDialog) { }

  ngOnInit(): void {
    this.userService.usersList().subscribe(list => {
      this.usersList = list;
    })

  }

  deleteUser( login: string ): void {
    console.log( login );
    this.userService.deleteUser( login ).subscribe(deleted => {
        console.log('TODO : Afficher confirmation au user');
    });
  }

  editUser ( user: User ): void {    
    const dialogRef = this.dialog.open(EditUserComponent,{
      data: {
        utilisateur : user
      }
    });

    dialogRef.afterClosed().subscribe(
      dialResult => {
        if ( dialResult != null ) {
          // console.log(dialResult.user.login);
          // this.userService.updateUser(dialResult.user.login).subscribe( updated => {
          //   console.log(' Updated ');
          // }) 
          console.log("updated ! ");
        } else {
          console.log("aucune modif");
        }
      }
    )
  }
}
